import { render, staticRenderFns } from "./list.vue?vue&type=template&id=21c5077f&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=21c5077f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c5077f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c5077f')) {
      api.createRecord('21c5077f', component.options)
    } else {
      api.reload('21c5077f', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=21c5077f&scoped=true&", function () {
      api.rerender('21c5077f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myIntegral/list.vue"
export default component.exports